var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeavy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.763,
    height: 39.703,
    viewBox: "0 0 29.763 39.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1065",
    "data-name": "Grupo 1065",
    transform: "translate(-2582.409 7331.987)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_329",
    "data-name": "L\\xEDnea 329",
    x1: 0.105,
    y2: 9.935,
    transform: "translate(2589.38 -7308.962)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_330",
    "data-name": "L\\xEDnea 330",
    x1: 0.079,
    y2: 7.453,
    transform: "translate(2604.914 -7307.721)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_331",
    "data-name": "L\\xEDnea 331",
    x1: 0.079,
    y2: 7.453,
    transform: "translate(2597.252 -7300.748)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7303",
    "data-name": "Trazado 7303",
    d: "M2605.143-7325.064c-.033,0-.065,0-.1,0a7.058,7.058,0,0,0-6.962-5.928,7.059,7.059,0,0,0-7,6.155,6.042,6.042,0,0,0-1.644-.232,6.032,6.032,0,0,0-6.031,6.031,6.03,6.03,0,0,0,6.031,6.029h15.7a6.029,6.029,0,0,0,6.03-6.029A6.031,6.031,0,0,0,2605.143-7325.064Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavy);
export default __webpack_public_path__ + "static/media/heavy.a1eef59d.svg";
export { ForwardRef as ReactComponent };